import React from 'react';

const GeographySection = () => {
  // All 24 regional capitals of Ukraine with verified coat of arms URLs
  const cities = [
    { 
      name: 'Київ', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/a/a8/Coat_of_arms_of_Kiev.svg'
    },
    { 
      name: 'Харків', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/7/71/Coat_of_arms_of_Kharkiv.svg'
    },
    { 
      name: 'Одеса', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/4/49/Coat_of_Arms_of_Odesa.svg'
    },
    { 
      name: 'Дніпро', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/2/21/Coat_of_arms_of_Dnipro.svg',
      highlight: true
    },
    { 
      name: 'Львів', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/7/79/Coat_of_arms_of_Lviv.svg'
    },
    { 
      name: 'Запоріжжя', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/9/96/%D0%93%D0%B5%D1%80%D0%B1_%D0%97%D0%B0%D0%BF%D0%BE%D1%80%D0%BE%D0%B6%D1%8C%D1%8F_2003_%D0%B3%D0%BE%D0%B4%D0%B0.svg'
    },
    { 
      name: 'Вінниця', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/e/e8/Coat_of_arms_of_Vinnytsia.svg'
    },
    { 
      name: 'Миколаїв', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/7/7f/Coat_of_arms_of_Nikolayev.svg'
    },
    { 
      name: 'Полтава', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/d/d7/Poltava_coat.svg'
    },
    { 
      name: 'Чернігів', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/2/20/Coat_of_Arms_of_Chernihiv.svg'
    },
    { 
      name: 'Черкаси', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/a/ae/COA_Cherkasy%2C_Cherkaska%2C_Ukraine.svg'
    },
    { 
      name: 'Житомир', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/3/37/Coat_of_arms_of_Zhytomyr.svg'
    },
    { 
      name: 'Суми', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/f/f8/Gerb_goroda_sumy.svg'
    },
    { 
      name: 'Рівне', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/e/e3/Coat_of_arms_Rivne.svg'
    },
    { 
      name: 'Хмельницький', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/a/a6/Coat_of_Arms_of_Khmelnitsky.svg'
    },
    { 
      name: 'Тернопіль', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/5/55/Coat_of_arms_of_Ternopil.svg'
    },
    { 
      name: 'Івано-Франківськ', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/2/2b/Ivano-Frankivsk_Coat_of_Arms.png'
    },
    { 
      name: 'Луцьк', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/3/3a/Herb_Lutsk.svg'
    },
    { 
      name: 'Ужгород', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/7/70/Coat_of_arms_of_Uzhhorod.svg'
    },
    { 
      name: 'Кропивницький', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/b/ba/Coat_of_Arms_of_Kropyvnytskyi.svg'
    },
    { 
      name: 'Херсон', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/d/d1/Coat_of_arms_of_Kherson.svg'
    },
    { 
      name: 'Чернівці', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/0/06/Coat_of_arms_of_Chernivtsi.svg'
    },
    { 
      name: 'Луганськ', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/c/cd/Coat_of_arms_of_Luhansk.svg'
    },
    { 
      name: 'Донецьк', 
      coat: 'https://upload.wikimedia.org/wikipedia/commons/8/81/Greater_Coat_of_Arms_of_Donetsk_%281995%29.svg'
    }
  ];

  return (
    <section id="geography" className="section-container">
      <div className="content-wrapper">
        <h2 className="section-title">Географія обслуговування</h2>
        <p className="section-description geography-description">
          Наш головний офіс розташований у Дніпрі. Ми надаємо юридичні послуги клієнтам по всій Україні — у всіх обласних центрах та містах.
        </p>
        
        <div className="cities-grid">
          {cities.map((city) => (
            <div 
              key={city.name} 
              className={`city-card ${city.highlight ? 'city-card-highlight' : ''}`}
            >
              <div className="city-coat-wrapper">
                <img 
                  src={city.coat} 
                  alt={`Герб ${city.name}`}
                  className="city-coat"
                  loading="lazy"
                />
              </div>
              <span className="city-name">{city.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GeographySection;
